import React from 'react';

import selectArrow from './assets/select-arrow.svg';

const Arrow = () => <img src={selectArrow} alt="Select arrow" />;

export default Arrow;
